import { ProviderNames } from "app/lib/data/models/Providers";
import { getAccountProvider, getInnerError } from "app/lib/utils/adaya/AdayaUtils";
import { getLogger } from "app/lib/utils/logging";
import ApiService from "../ApiService";
import AuthService from "../AuthService";

const log = getLogger('AmazonAdsService', { color: 'green', enabled: false }).log;

class AmazonAdsService {

    public getProfile = async (userId) => {
        return new Promise((resolve, reject) => {
            // todo: query google
            return resolve({ id: '1', email: 'rw3iss@gmail.com', name: 'Ryan Weiss' });
        });
    };


    public getAuthUrl = async () => {
        return await ApiService.get(`${process.env.API_URL}/amazon_ads-auth-url`);
    };

    // Get access_token and advertisers
    public getAccountInfo = async (code: string) => {
        try {
            const r = await ApiService.get(`${process.env.API_URL}/amazon_ads-callback${code}`);
            console.log(`Amazon Ads callback response`, r);
            if (r.success) return r;
            throw getInnerError(r);
        } catch (e) {
            throw getInnerError(e);
        }
    };

    /**
     * @description Requests the given TikTok user be connected to the account.
     * @param {*} data
     */
    public connectAmazonAccount = async (data) => {
        console.log(data);
        try {
            let r = await ApiService.post(`${process.env.API_URL}/users/provider/amazon_ads`, {
                access_token: data.access_token,
                refresh_token: data.refresh_token,
                profile_id: data.profile_id
            });
            if (r.success) return r.user;
            throw getInnerError(r);
        } catch (e) {
            throw getInnerError(e);
        }
    };

    // Todo: finish
    public tryUpdateToken = async (r, user) => {
        let update = false;

        if (await this.isOriginalUser(r.authResponse, user)) {
            log('IS ORIGINAL USER, updating token.');
            if (r.status === 'connected') {
                update = true;
            }
        }

        if (update) {
            // log("Updating long token...");
            // debug(user, "Updating Google token.", { fbAccessToken: r.authResponse.accessToken });
            // const tr = await this.getAndSaveLongToken(r.authResponse.accessToken, r.authResponse.userID);
            // log('Saved long token...');
            // if (tr) {
            //     // get a new user object if the original user was set on the account
            //     let authed = await AuthService.checkSession() !== false;
            //     if (authed) await AuthService.updateCurrentUser(user);
            //     return true;
            // }
        } else {
            log('cant update TikTok token because its a mock user and we cant find the FB profile.');
        }

        return false;
    };

    // Todo: finish
    public isOriginalUser = async (status, user) => {
        try {
            log('isOriginalUser?', status, user);

            // if no user is given, we assume original (ie. for signup page, etc):
            user = user || AuthService.getCurrentUser();
            if (!user) {
                return true;
            }

            let provider = getAccountProvider(user.activeAccount, ProviderNames.TIKTOK);

            if (provider && status) {
                // TODO:.........................
                if (provider.oauth?.accountUserId) {
                    // if account user id matches current, it's original user.
                    if (provider.oauth.accountUserId == status.userID) {
                        return true;
                    }
                }

                return false;
            }
        } catch (e) {
            console.log('TikTok isOriginalUser error', e);
        }
        return false;
    };


}

export default new AmazonAdsService();